import { useState, useCallback } from 'react';
import { deleteInsuranceCompany } from '../api/insurance';

interface UseDeleteInsuranceCompanyResult {
  deleteCompany: (id: number) => Promise<void>;
  isLoading: boolean;
  error: string | null;
  reset: () => void;
}

export function useDeleteInsuranceCompany(
  onSuccess?: () => void
): UseDeleteInsuranceCompanyResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteItem = useCallback(
    async (id: number): Promise<void> => {
      setIsLoading(true);
      setError(null);
      try {
        await deleteInsuranceCompany(id);
        onSuccess?.();
      } catch (err) {
        const apiError = err as { response?: { data?: { message?: string } } };
        const message =
          apiError.response?.data?.message || 'Failed to deactivate insurance company';
        setError(message);
        throw err;
      } finally {
        setIsLoading(false);
      }
    },
    [onSuccess]
  );

  const reset = useCallback(() => {
    setError(null);
  }, []);

  return { deleteCompany: deleteItem, isLoading, error, reset };
}
